import { Container } from './sitewide-notice-banner.styles'

const SitewideNoticeBanner = () => (
  <Container>
    In a few weeks, we will be releasing a new Protect website experience with a brand new design and enhanced
    performance.
  </Container>
)

export default SitewideNoticeBanner
